/* Sethukrishna — Modern Heirloom interactions (lightweight, no dependencies) */
(function () {
  var doc = document.documentElement;
  if (window.Shopify && Shopify.designMode) doc.classList.add('sk-design-mode');

  /* Reveal on scroll */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-sk-reveal]:not(.sk-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('sk-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sk-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      if (el.hasAttribute('data-sk-stagger')) el.style.setProperty('--sk-delay', (el.getAttribute('data-sk-stagger') * 0.08) + 's');
      io.observe(el);
    });
  }

  /* Header shadow once the page scrolls */
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { doc.classList.toggle('sk-scrolled', window.scrollY > 8); ticking = false; });
  }

  /* Rail arrows */
  function initRails(root) {
    (root || document).querySelectorAll('[data-sk-rail]').forEach(function (wrap) {
      if (wrap.dataset.skReady) return; wrap.dataset.skReady = '1';
      var rail = wrap.querySelector('.sk-rail');
      if (!rail) return;
      wrap.querySelectorAll('[data-sk-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = Number(btn.getAttribute('data-sk-dir'));
          rail.scrollBy({ left: dir * rail.clientWidth * 0.85, behavior: 'smooth' });
        });
      });
    });
  }

  function init(root) { initReveal(root); initRails(root); }

  document.addEventListener('DOMContentLoaded', function () { init(); onScroll(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
